import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import BannerComponent from '../../components/layout/banner/main';
import LiveNewsTicker from '../../components/layout/live-news-ticker';
import PopularPosts from '../../components/widget/sidebar/popular-posts';
import LatestReviews from '../../components/widget/sidebar/latest-reviews';
import LiveStreams from '../../components/widget/sidebar/live-streams';
import LatestComments from '../../components/widget/sidebar/latest-comments';
import PixelPoll from '../../components/widget/sidebar/pixel-poll';
import FeaturedVideo from '../../components/widget/sidebar/featured-video';
import TagCloud from '../../components/widget/sidebar/tag-cloud';
import Calendar from '../../components/widget/sidebar/calendar';
import SidebarSearch from '../../components/widget/sidebar/search';
import PostPreview from '../../components/layout/post-preview';
import Pagination from '../../components/pagination';

class ReviewsIndexComponent extends Component {
  <template>
    <BannerComponent @theme='game-review' @title='Game Reviews' />
    <LiveNewsTicker />
    <div class='layout-content-1 layout-item-3-1 grid-limit'>
      <div class='layout-body'>
        <div class='layout-item gutter-big'>
          {{#each @model.articles as |article|}}
            <PostPreview @type='game-review' @post={{article}} />
          {{/each}}
        </div>
        <Pagination
          @currentPage={{@model.pagination.currentPage}}
          @totalCount={{@model.pagination.totalCount}}
          @limit={{@model.pagination.limit}}
          @hasPreviousPage={{@model.pagination.hasPreviousPage}}
          @hasNextPage={{@model.pagination.hasNextPage}}
          @route='reviews.index'
        />
      </div>
      <div class='layout-sidebar layout-item gutter-medium'>
        <SidebarSearch />
        <LatestReviews />
        <PopularPosts />
        <LiveStreams />
        <LatestComments />
        <PixelPoll />
        <FeaturedVideo />
        <TagCloud />
        <Calendar />
      </div>
    </div>
  </template>
}
export default RouteTemplate(ReviewsIndexComponent);
